import React, { useState, useEffect, useCallback, useMemo } from "react";
import { MapPin, X, Minus, Plus, CheckCircle } from "lucide-react";
import headerImg from "./images/mainHeader.webp";
import { apiUrl } from "../../constants";

// Row 1
import firstLogo from "./images/camelRide.webp";
import secondLogo from "./images/RajisthaniMusic.webp";
import thirdLogo from "./images/RajisthaniMagic.webp";
import fourthLogo from "./images/RajisthaniDance.webp";
import firstposter from "./images/Camelrideposter.webp";
import secondposter from "./images/RajasthaniMusicposter.webp";
import thirdposter from "./images/RajasthaniMagicshowposter.webp";
import fourthposter from "./images/RajasthaniDanceposter.webp";

// Row 2
import fifthLogo from "./images/dance.webp";
import sixthLogo from "./images/gulal.webp";
import seventhLogo from "./images/thandai.webp";
import eighthLogo from "./images/UnlimtedFood.webp";
import fifthposter from "./images/Raindanceposter.webp";
import sixthposter from "./images/Unlimitedherbalgulaalposter.webp";
import seventhposter from "./images/Thandaiposter.webp";
import eighthposter from "./images/Unlimitedfoodposter.webp";

// Row 3
import ninthLogo from "./images/GiantSwing.webp";
import tenthLogo from "./images/BurmaBridge.webp";
import eleventhLogo from "./images/Zipline.webp";
import twelfthLogo from "./images/Skycycle.webp";

// Row 4
import thirteenthLogo from "./images/Theme.webp";
import fourteenthLogo from "./images/Costume.webp";
import fifteenthLogo from "./images/DjDisco.webp";
import sixteenthLogo from "./images/carnival.webp";

// Row 1
import firstbg from "./images/camelridebg.webp";
import secondbg from "./images/rajasathanimusicbg.webp";
import thirdbg from "./images/magicshowbg.webp";
import fourthbg from "./images/rajasthanidancebg.webp";

// Row 2
import fifthbg from "./images/unlimitedraindancebg.webp";
import sixthbg from "./images/unlimitedherbalgulalbg.webp";
import seventhbg from "./images/unlimitedthandaibg.webp";
import eighthbg from "./images/unlimitedfoodbg.webp";

// Row 3
import ninthbg from "./images/giantswingbg.webp";
import tenthbg from "./images/burmabridgebg.webp";
import eleventhbg from "./images/ziplinebg.webp";
import twelfthbg from "./images/skycyclebg.webp";

// Row 4
import thirteenthbg from "./images/selfiepointbg.webp";
import fourteenthbg from "./images/costumephotoboothbg.webp";
import fifteenthbg from "./images/discodjbg.webp";
import sixteenthbg from "./images/carnivalgamesbg.webp";

// Holi moments carousel videos - HOSTED ON CLOUDINARY

const video1 =
  "https://res.cloudinary.com/di1h5uspj/video/upload/v1770971507/1_v8hwqf.mp4";
const video2 =
  "https://res.cloudinary.com/di1h5uspj/video/upload/v1770971472/2_neujp6.mp4";
const video3 =
  "https://res.cloudinary.com/di1h5uspj/video/upload/v1770971515/3_sjxrcv.mp4";
const video4 =
  "https://res.cloudinary.com/di1h5uspj/video/upload/v1770971469/4_kko32u.mp4";
const video5 =
  "https://res.cloudinary.com/di1h5uspj/video/upload/v1770971473/5_mj1ph8.mp4";
const video6 =
  "https://res.cloudinary.com/di1h5uspj/video/upload/v1770971471/6_qs6ema.mp4";

const HoliPage = () => {
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [isBookingModalOpen, setIsBookingModalOpen] = useState(false);
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [bookingDetails, setBookingDetails] = useState({
    ticketCount: 0,
    totalPrice: 0,
  });
  const [currentSlide, setCurrentSlide] = useState(0);
  const [videosLoaded, setVideosLoaded] = useState(false);

  const [formData, setFormData] = useState({
    userName: "",
    phoneNumber: "",
    email: "",
    tickets: {
      category_0_5: 0,
      category_5_10: 0,
      category_10_above: 0,
    },
  });

  // Ticket prices
  const ticketPrices = useMemo(
    () => ({
      category_5_10: 699,
      category_10_above: 999,
    }),
    [],
  );

  // Calculate total amount - memoized
  const calculateTotal = useCallback(() => {
    return (
      formData.tickets.category_5_10 * ticketPrices.category_5_10 +
      formData.tickets.category_10_above * ticketPrices.category_10_above
    );
  }, [formData.tickets, ticketPrices]);

  // Calculate total tickets - memoized
  const getTotalTickets = useCallback(() => {
    return formData.tickets.category_5_10 + formData.tickets.category_10_above;
  }, [formData.tickets]);

  // Handle ticket increment/decrement - memoized
  const updateTicketCount = useCallback((category, increment) => {
    setFormData((prev) => ({
      ...prev,
      tickets: {
        ...prev.tickets,
        [category]: Math.max(0, prev.tickets[category] + (increment ? 1 : -1)),
      },
    }));
  }, []);

  // Handle form submission - memoized
  const handleSubmit = useCallback(
    async (e) => {
      e.preventDefault();

      // Validation
      if (!formData.userName || !formData.phoneNumber) {
        alert("Please fill in all required fields");
        return;
      }

      if (getTotalTickets() === 0) {
        alert("Please select at least one ticket");
        return;
      }

      setIsSubmitting(true);

      try {
        const response = await fetch(`${apiUrl}/event/create`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            userName: formData.userName,
            phoneNumber: formData.phoneNumber,
            email: formData.email,
            totalAmount: calculateTotal(),
            paidAmount: 0,
            paymentMode: "cash",
            tickets: formData.tickets,
          }),
        });

        const data = await response.json();

        if (data.success) {
          setIsBookingModalOpen(false);
          setIsSuccessModalOpen(true);

          setBookingDetails({
            ticketCount: getTotalTickets(),
            totalPrice: calculateTotal(),
          });

          // Reset form
          setFormData({
            userName: "",
            phoneNumber: "",
            email: "",
            tickets: {
              category_0_5: 0,
              category_5_10: 0,
              category_10_above: 0,
            },
          });
        }
      } catch (error) {
        console.error("Error creating booking:", error);
        alert("Failed to create booking. Please try again.");
      } finally {
        setIsSubmitting(false);
      }
    },
    [formData, calculateTotal, getTotalTickets],
  );

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (isBookingModalOpen || selectedEvent || isSuccessModalOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }

    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isBookingModalOpen, selectedEvent, isSuccessModalOpen]);

  // Event highlights data - memoized
  const eventHighlights = useMemo(
    () => [
      {
        title: "Camel Ride",
        icon: firstLogo,
        bgImage: firstbg,
        overlayColor:
          "from-[hsla(38,6%,100%,0)] via-[hsla(0,0%,100%,0)] to-[hsla(200,70%,89%,1)]",
        poster: firstposter,
      },
      {
        title: "Rajasthani Music",
        icon: secondLogo,
        bgImage: secondbg,
        overlayColor: "from-white/40 to-purple-200/50",
        poster: secondposter,
      },
      {
        title: "Rajasthani Magic Show",
        icon: thirdLogo,
        bgImage: thirdbg,
        overlayColor: "from-white/40 to-pink-200/50",
        poster: thirdposter,
      },
      {
        title: "Rajasthani Dance",
        icon: fourthLogo,
        bgImage: fourthbg,
        overlayColor: "from-white/40 to-rose-200/50",
        poster: fourthposter,
      },
      {
        title: "Unlimited Rain Dance",
        icon: fifthLogo,
        bgImage: fifthbg,
        overlayColor: "from-white/40 to-sky-300/50",
        poster: fifthposter,
      },
      {
        title: "Unlimited Herbal Gulal",
        icon: sixthLogo,
        bgImage: sixthbg,
        overlayColor: "from-white/40 to-orange-200/50",
        poster: sixthposter,
      },
      {
        title: "Unlimited Thandai",
        icon: seventhLogo,
        bgImage: seventhbg,
        overlayColor: "from-white/40 to-green-200/50",
        poster: seventhposter,
      },
      {
        title: "Unlimited Food",
        icon: eighthLogo,
        bgImage: eighthbg,
        overlayColor: "from-white/40 to-yellow-200/50",
        poster: eighthposter,
      },
      {
        title: "Giant Swing",
        icon: ninthLogo,
        bgImage: ninthbg,
        overlayColor: "from-white/40 to-blue-200/50",
        poster:
          "https://images.unsplash.com/photo-1520095972714-909e91b038e5?w=1080&h=1350&fit=crop",
      },
      {
        title: "Burma Bridge",
        icon: tenthLogo,
        bgImage: tenthbg,
        overlayColor: "from-white/40 to-teal-200/50",
        poster:
          "https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=1080&h=1350&fit=crop",
      },
      {
        title: "Zipline",
        icon: eleventhLogo,
        bgImage: eleventhbg,
        overlayColor: "from-white/40 to-indigo-200/50",
        poster:
          "https://images.unsplash.com/photo-1527004013197-933c4bb611b3?w=1080&h=1350&fit=crop",
      },
      {
        title: "Skycycle",
        icon: twelfthLogo,
        bgImage: twelfthbg,
        overlayColor: "from-white/40 to-violet-200/50",
        poster:
          "https://images.unsplash.com/photo-1534787238916-9ba6764efd4f?w=1080&h=1350&fit=crop",
      },
      {
        title: "Themed Selfie Zones",
        icon: thirteenthLogo,
        bgImage: thirteenthbg,
        overlayColor: "from-white/40 to-fuchsia-200/50",
        poster:
          "https://images.unsplash.com/photo-1516035069371-29a1b244cc32?w=1080&h=1350&fit=crop",
      },
      {
        title: "Costume Photo Booths",
        icon: fourteenthLogo,
        bgImage: fourteenthbg,
        overlayColor: "from-white/40 to-cyan-200/50",
        poster:
          "https://images.unsplash.com/photo-1492684223066-81342ee5ff30?w=1080&h=1350&fit=crop",
      },
      {
        title: "Disco DJ",
        icon: fifteenthLogo,
        bgImage: fifteenthbg,
        overlayColor: "from-white/40 to-purple-300/50",
        poster:
          "https://images.unsplash.com/photo-1470225620780-dba8ba36b745?w=1080&h=1350&fit=crop",
      },
      {
        title: "Carnival Games",
        icon: sixteenthLogo,
        bgImage: sixteenthbg,
        overlayColor: "from-white/40 to-lime-200/50",
        poster:
          "https://images.unsplash.com/photo-1529448005898-b19fc13465b7?w=1080&h=1350&fit=crop",
      },
    ],
    [],
  );

  // Holi moments carousel videos
  const holiMoments = useMemo(
    () => [
      {
        type: "video",
        src: video1,
        title: "Colorful Celebrations",
      },
      {
        type: "video",
        src: video2,
        title: "Dance & Music",
      },
      {
        type: "video",
        src: video3,
        title: "Rain Dance Fun",
      },
      {
        type: "video",
        src: video4,
        title: "Family Moments",
      },
      {
        type: "video",
        src: video5,
        title: "Adventure Time",
      },
      {
        type: "video",
        src: video6,
        title: "Fun Activities",
      },
    ],
    [],
  );

  // Get slides per view based on screen size
  const [slidesPerView, setSlidesPerView] = useState(1);

  useEffect(() => {
    const updateSlidesPerView = () => {
      if (window.innerWidth >= 1024) {
        setSlidesPerView(4);
      } else if (window.innerWidth >= 640) {
        setSlidesPerView(2);
      } else {
        setSlidesPerView(1);
      }
    };

    updateSlidesPerView();
    window.addEventListener("resize", updateSlidesPerView);
    return () => window.removeEventListener("resize", updateSlidesPerView);
  }, []);

  // Auto-slide carousel - only when videos are in view
  useEffect(() => {
    if (!videosLoaded) return;

    const timer = setTimeout(() => {
      const interval = setInterval(() => {
        setCurrentSlide((prev) => {
          const maxSlide = holiMoments.length - slidesPerView;
          return prev >= maxSlide ? 0 : prev + 1;
        });
      }, 3500);

      return () => clearInterval(interval);
    }, 500);

    return () => clearTimeout(timer);
  }, [holiMoments.length, videosLoaded, slidesPerView]);

  // Intersection Observer for lazy loading videos
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setVideosLoaded(true);
            observer.disconnect();
          }
        });
      },
      { threshold: 0.1 },
    );

    const videoSection = document.getElementById("holi-moments-section");
    if (videoSection) {
      observer.observe(videoSection);
    }

    return () => observer.disconnect();
  }, []);

  // Memoized handlers
  const handleEventClick = useCallback((event) => {
    setSelectedEvent(event);
  }, []);

  const handleCloseEvent = useCallback(() => {
    setSelectedEvent(null);
  }, []);

  const handleOpenBooking = useCallback(() => {
    setIsBookingModalOpen(true);
  }, []);

  const handleCloseBooking = useCallback(() => {
    setIsBookingModalOpen(false);
  }, []);

  const handleCloseSuccess = useCallback(() => {
    setIsSuccessModalOpen(false);
  }, []);

  const handleOpenBookingFromEvent = useCallback(() => {
    setSelectedEvent(null);
    setIsBookingModalOpen(true);
  }, []);

  const handleSlideChange = useCallback((index) => {
    setCurrentSlide(index);
  }, []);

  const handlePrevSlide = useCallback(() => {
    setCurrentSlide((prev) =>
      prev === 0 ? Math.ceil(holiMoments.length / slidesPerView) - 1 : prev - 1,
    );
  }, [holiMoments.length, slidesPerView]);

  const handleNextSlide = useCallback(() => {
    setCurrentSlide((prev) => {
      const maxSlide = Math.ceil(holiMoments.length / slidesPerView) - 1;
      return prev >= maxSlide ? 0 : prev + 1;
    });
  }, [holiMoments.length, slidesPerView]);

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
      {/* Hero Image Section */}
      <div className="relative w-full overflow-hidden bg-gradient-to-b from-blue-400 to-blue-600">
        <img
          src={headerImg}
          alt="Funingo Adventure Arena Hero"
          className="w-full h-auto object-contain"
          loading="eager"
        />
      </div>

      {/* Date, Time and Book Now Section */}
      <div className="bg-gradient-to-br from-blue-800 via-blue-500 to-white py-6 sm:py-8 px-4">
        <div className="max-w-5xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center justify-center gap-4 lg:gap-6">
            {/* Date and Time Container */}
            <div className="bg-white rounded-full px-4 sm:px-8 py-3 sm:py-5 shadow-lg w-full lg:w-auto">
              <div className="flex items-center justify-center gap-3 sm:gap-8">
                {/* Date Section */}
                <div className="flex items-center gap-2 sm:gap-3">
                  <svg
                    className="w-4 h-4 sm:w-6 sm:h-6 text-gray-700 flex-shrink-0"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
                    />
                  </svg>
                  <div>
                    <div className="text-[10px] sm:text-sm text-gray-500 font-medium uppercase tracking-wide">
                      Date
                    </div>
                    <div className="text-xs sm:text-lg font-bold text-gray-900">
                      04 March 2026
                    </div>
                  </div>
                </div>

                {/* Vertical Separator */}
                <div className="w-px h-10 sm:h-14 bg-gray-300"></div>

                {/* Time Section */}
                <div className="flex items-center gap-2 sm:gap-3">
                  <svg
                    className="w-4 h-4 sm:w-6 sm:h-6 text-gray-700 flex-shrink-0"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                    />
                  </svg>
                  <div>
                    <div className="text-[10px] sm:text-sm text-gray-500 font-medium uppercase tracking-wide">
                      Time
                    </div>
                    <div className="text-xs sm:text-lg font-bold text-gray-900">
                      10:00AM - 6:00PM
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Book Now Button */}
            <button
              onClick={handleOpenBooking}
              className="bg-yellow-400 text-gray-900 px-16 sm:px-20 py-4 sm:py-5 rounded-full font-bold text-lg sm:text-xl hover:bg-yellow-300 transition-all shadow-lg transform hover:scale-105 uppercase w-full lg:w-auto"
            >
              Book Now
            </button>
          </div>
        </div>
      </div>

      {/* Event Highlights Section */}
      <div className="max-w-7xl mx-auto px-4 py-16 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2
            className="text-4xl sm:text-5xl font-black text-gray-900 mb-3"
            style={{ fontFamily: "'Poppins', sans-serif" }}
          >
            Event Highlights
          </h2>
          <p
            className="text-xl text-gray-600 font-medium"
            style={{ fontFamily: "'Poppins', sans-serif" }}
          >
            Activities included with every ticket
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-6">
          {eventHighlights.map((event, index) => (
            <div
              key={index}
              onClick={() => handleEventClick(event)}
              className="group relative overflow-hidden transition-all duration-300 transform hover:scale-105 cursor-pointer will-change-transform"
              style={{
                background:
                  "linear-gradient(to bottom, rgba(255, 255, 255, 0.4), rgba(135, 206, 235, 0.5))",
                border: "3px solid #f97316",
                borderRadius: "2rem",
                boxShadow:
                  "0 8px 25px rgba(249, 115, 22, 0.3), 0 4px 12px rgba(0, 0, 0, 0.15)",
              }}
            >
              {/* Full background image with low opacity */}
              <div className="absolute inset-0 opacity-15">
                <img
                  src={event.bgImage}
                  alt=""
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>

              {/* Gradient overlay */}
              <div
                className={`absolute inset-0 bg-gradient-to-b ${event.overlayColor}`}
                style={{ borderRadius: "2rem" }}
              ></div>

              {/* Diagonal line for flag string */}
              <div
                className="absolute top-0 left-0 right-0 h-[2px] bg-gray-400 z-10"
                style={{
                  width: "100%",
                  margin: "0 auto",
                }}
              ></div>

              {/* Colorful flag bunting - spanning across top */}
              <div className="absolute top-0 left-0 right-0 flex justify-between px-2 z-20">
                {/* Left side flags */}
                <div className="flex">
                  <div className="w-0 h-0 border-l-[11px] border-l-transparent border-r-[11px] border-r-transparent border-t-[15px] border-t-pink-400"></div>
                  <div className="w-0 h-0 border-l-[11px] border-l-transparent border-r-[11px] border-r-transparent border-t-[15px] border-t-cyan-400"></div>
                  <div className="w-0 h-0 border-l-[11px] border-l-transparent border-r-[11px] border-r-transparent border-t-[15px] border-t-yellow-400"></div>
                </div>

                {/* Right side flags */}
                <div className="flex">
                  <div className="w-0 h-0 border-l-[11px] border-l-transparent border-r-[11px] border-r-transparent border-t-[15px] border-t-yellow-400"></div>
                  <div className="w-0 h-0 border-l-[11px] border-l-transparent border-r-[11px] border-r-transparent border-t-[15px] border-t-cyan-400"></div>
                  <div className="w-0 h-0 border-l-[11px] border-l-transparent border-r-[11px] border-r-transparent border-t-[15px] border-t-pink-400"></div>
                </div>
              </div>

              {/* Main content */}
              <div className="relative z-20 p-6 flex flex-col items-center justify-between h-full">
                {/* Center Image */}
                <div className="flex-1 flex items-center justify-center mt-6 mb-4">
                  <div className="w-32 h-32 sm:w-40 sm:h-40 rounded-2xl overflow-hidden">
                    <img
                      src={event.icon}
                      alt={event.title}
                      className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                      loading="lazy"
                    />
                  </div>
                </div>

                {/* Bottom Text */}
                <div className="bg-white/80 backdrop-blur-sm rounded-2xl px-4 py-3 w-full">
                  <h3
                    className="text-center font-bold text-gray-900 text-sm sm:text-base"
                    style={{ fontFamily: "'Poppins', sans-serif" }}
                  >
                    {event.title}
                  </h3>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Holi Moments Carousel Section */}
      <div
        id="holi-moments-section"
        className="bg-gradient-to-r from-pink-50 via-purple-50 to-blue-50 py-16"
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2
              className="text-4xl sm:text-5xl font-black text-gray-900 mb-3"
              style={{ fontFamily: "'Poppins', sans-serif" }}
            >
              Glimpse of Funingo Holi 1.0
            </h2>
            <p
              className="text-xl text-gray-600 font-medium"
              style={{ fontFamily: "'Poppins', sans-serif" }}
            >
              Experience the Joy & Energy
            </p>
          </div>

          {/* Carousel Container */}
          <div className="relative overflow-hidden">
            {/* Carousel Track */}
            <div
              className="flex transition-transform duration-700 ease-in-out will-change-transform"
              style={{
                transform: `translateX(-${currentSlide * (100 / slidesPerView)}%)`,
              }}
            >
              {holiMoments.map((moment, index) => (
                <div
                  key={index}
                  className="flex-shrink-0 px-3 w-full sm:w-1/2 lg:w-1/4"
                >
                  <div className="relative rounded-3xl overflow-hidden shadow-2xl bg-gray-200 h-[500px] sm:h-[400px] lg:h-[450px]">
                    {videosLoaded ? (
                      <video
                        src={moment.src}
                        className="w-full h-full object-cover"
                        autoPlay
                        loop
                        muted
                        playsInline
                        preload="metadata"
                      />
                    ) : (
                      <div className="w-full h-full bg-gradient-to-br from-pink-200 to-purple-200 flex items-center justify-center">
                        <div className="text-center">
                          <div className="w-16 h-16 border-4 border-white border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
                          <p className="text-white font-bold">
                            Loading videos...
                          </p>
                        </div>
                      </div>
                    )}

                    {/* Title overlay */}
                    <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-4 sm:p-6">
                      <h3
                        className="text-white text-lg sm:text-2xl font-bold"
                        style={{ fontFamily: "'Poppins', sans-serif" }}
                      >
                        {moment.title}
                      </h3>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Navigation Dots */}
            <div className="flex justify-center gap-2 mt-8">
              {Array.from({
                length: Math.ceil(holiMoments.length / slidesPerView),
              }).map((_, index) => (
                <button
                  key={index}
                  onClick={() => handleSlideChange(index)}
                  className={`w-3 h-3 rounded-full transition-all ${
                    currentSlide === index
                      ? "bg-blue-600 w-8"
                      : "bg-gray-300 hover:bg-gray-400"
                  }`}
                  aria-label={`Go to slide ${index + 1}`}
                />
              ))}
            </div>

            {/* Previous Button */}
            <button
              onClick={handlePrevSlide}
              className="absolute left-2 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white rounded-full p-3 shadow-lg transition-all z-10"
              aria-label="Previous slide"
            >
              <svg
                className="w-6 h-6 text-gray-800"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M15 19l-7-7 7-7"
                />
              </svg>
            </button>

            {/* Next Button */}
            <button
              onClick={handleNextSlide}
              className="absolute right-2 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white rounded-full p-3 shadow-lg transition-all z-10"
              aria-label="Next slide"
            >
              <svg
                className="w-6 h-6 text-gray-800"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>

      {/* Location Section */}
      <div className="max-w-7xl mx-auto px-4 py-16 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2
            className="text-4xl sm:text-5xl font-black text-gray-900 mb-3"
            style={{ fontFamily: "'Poppins', sans-serif" }}
          >
            Location
          </h2>
          <p
            className="text-xl text-gray-600 font-medium"
            style={{ fontFamily: "'Poppins', sans-serif" }}
          >
            Find Your Way to Funingo Adventure Arena
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 items-center">
          <div className="rounded-3xl overflow-hidden shadow-xl h-96">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3670.500384053639!2d79.90874247372597!3d23.07877151423171!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3981b1d2e4c6050f%3A0x540066db45c44e8f!2sFuningo%20Adventure%20Arena!5e0!3m2!1sen!2sin!4v1770815539459!5m2!1sen!2sin"
              className="w-full h-full border-0"
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Funingo Adventure Arena Location"
            ></iframe>
          </div>

          <div className="bg-gradient-to-br from-blue-800 via-blue-500 to-white rounded-3xl p-8 shadow-xl text-white">
            <div className="flex items-start gap-4 mb-6">
              <div className="bg-yellow-400 p-3 rounded-full">
                <MapPin className="w-8 h-8 text-blue-600" />
              </div>
              <div>
                <h3
                  className="text-2xl font-bold mb-2"
                  style={{ fontFamily: "'Poppins', sans-serif" }}
                >
                  Funingo Adventure Arena
                </h3>
                <p
                  className="text-blue-100"
                  style={{ fontFamily: "'Poppins', sans-serif" }}
                >
                  Manegaon, Nagpur Road, Jabalpur
                </p>
              </div>
            </div>

            <button
              className="w-full bg-yellow-400 text-gray-900 px-8 py-4 rounded-full font-bold text-lg hover:bg-yellow-300 transition-all shadow-lg transform hover:scale-105"
              onClick={() =>
                window.open(
                  "https://maps.app.goo.gl/xH5J8W2mMP5PxPAg7",
                  "_blank",
                )
              }
            >
              Get Directions
            </button>
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="bg-gradient-to-br from-blue-800 via-blue-500 to-white py-6 sm:py-8 px-4">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2
            className="text-4xl sm:text-5xl font-black text-yellow-400 mb-4"
            style={{ fontFamily: "'Poppins', sans-serif" }}
          >
            Limited Seats Available
          </h2>
          <h3
            className="text-3xl sm:text-4xl font-black text-white mb-6"
            style={{ fontFamily: "'Poppins', sans-serif" }}
          >
            Book Early
          </h3>
          <p
            className="text-xl text-white/90 mb-8 max-w-2xl mx-auto"
            style={{ fontFamily: "'Poppins', sans-serif" }}
          >
            Don't miss out on this extraordinary celebration of colors, culture,
            and adventure
          </p>

          <button
            onClick={handleOpenBooking}
            className="bg-yellow-400 text-gray-900 px-12 py-4 rounded-full font-bold text-xl hover:bg-yellow-300 transition-all shadow-2xl transform hover:scale-105 inline-flex items-center gap-3"
          >
            RESERVE YOUR SPOT
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={3}
                d="M13 7l5 5m0 0l-5 5m5-5H6"
              />
            </svg>
          </button>
        </div>
      </div>

      {/* Event Detail Modal */}
      {selectedEvent && (
        <div
          className="fixed inset-0 bg-black/70 backdrop-blur-sm z-[9999] flex items-center justify-center p-2 sm:p-4 animate-fadeIn"
          onClick={handleCloseEvent}
        >
          <div
            className="relative rounded-2xl sm:rounded-3xl shadow-2xl w-auto max-w-[95vw] sm:max-w-[85vw] max-h-[95dvh] sm:max-h-[90dvh] flex flex-col overflow-hidden animate-scaleIn"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close Button */}
            <button
              onClick={handleCloseEvent}
              className="absolute top-2 right-2 sm:top-4 sm:right-4 z-10 bg-white/90 hover:bg-white rounded-full p-2 shadow-lg transition-all transform hover:scale-110"
            >
              <X className="w-5 h-5 sm:w-6 sm:h-6 text-gray-800" />
            </button>

            {/* Poster Image - Full size */}
            <div className="relative">
              <img
                src={selectedEvent.poster}
                alt={selectedEvent.title}
                className="w-auto h-auto max-w-[95vw] sm:max-w-[85vw] max-h-[82dvh] sm:max-h-[78dvh] object-contain rounded-t-2xl sm:rounded-t-3xl"
                loading="lazy"
              />
            </div>

            {/* Button Section - Fixed at bottom */}
            <div className="flex-shrink-0 p-3 sm:p-4 bg-gradient-to-b from-blue-50 to-white rounded-b-2xl sm:rounded-b-3xl">
              <button
                onClick={handleOpenBookingFromEvent}
                className="w-full bg-gradient-to-r from-blue-600 to-blue-700 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-full font-bold text-base sm:text-lg hover:from-blue-700 hover:to-blue-800 transition-all shadow-lg transform hover:scale-105"
              >
                Grab your pass
              </button>
            </div>
          </div>
        </div>
      )}
      {/* Booking modal */}
      {isBookingModalOpen && (
        <>
          {/* Backdrop */}
          <div
            className="fixed inset-0 bg-black/80 backdrop-blur-md z-[9998]"
            onClick={handleCloseBooking}
          />

          {/* Modal */}
          <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4 pointer-events-none">
            <div
              className="w-full max-w-2xl bg-white rounded-3xl shadow-2xl overflow-hidden pointer-events-auto max-h-[90vh] overflow-y-auto relative animate-scaleIn"
              onClick={(e) => e.stopPropagation()}
            >
              {/* Close Button */}
              <button
                onClick={handleCloseBooking}
                className="absolute top-4 right-4 z-50 w-10 h-10 bg-red-500 hover:bg-red-600 rounded-full flex items-center justify-center transition-colors shadow-lg"
              >
                <X className="w-6 h-6 text-white" />
              </button>

              {/* Modal Header with Image */}
              <div className="relative overflow-hidden">
                <img
                  src={headerImg}
                  alt="Funingo Holi 2.0"
                  className="w-full h-auto object-cover"
                  style={{ display: "block" }}
                  loading="lazy"
                />
              </div>

              {/* Form */}
              <form onSubmit={handleSubmit} className="p-6 sm:p-8 relative">
                <div
                  className="absolute inset-0 pointer-events-none"
                  style={{
                    backgroundImage: `url(${firstbg})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    opacity: 0.09,
                    zIndex: 0,
                  }}
                />

                {/* Personal Details */}
                <div className="space-y-4 mb-6 relative z-10">
                  <div>
                    <label className="block text-gray-700 font-bold mb-2">
                      Name <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      required
                      value={formData.userName}
                      onChange={(e) =>
                        setFormData({ ...formData, userName: e.target.value })
                      }
                      className="w-full px-4 py-3 border-2 border-blue-200 rounded-xl focus:border-blue-500 focus:outline-none transition-colors"
                      placeholder="Enter your name"
                    />
                  </div>

                  <div>
                    <label className="block text-gray-700 font-bold mb-2">
                      Phone Number <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="tel"
                      required
                      value={formData.phoneNumber}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          phoneNumber: e.target.value,
                        })
                      }
                      className="w-full px-4 py-3 border-2 border-blue-200 rounded-xl focus:border-blue-500 focus:outline-none transition-colors"
                      placeholder="Enter your phone number"
                    />
                  </div>

                  <div>
                    <label className="block text-gray-700 font-bold mb-2">
                      Email (Optional)
                    </label>
                    <input
                      type="email"
                      value={formData.email}
                      onChange={(e) =>
                        setFormData({ ...formData, email: e.target.value })
                      }
                      className="w-full px-4 py-3 border-2 border-blue-200 rounded-xl focus:border-blue-500 focus:outline-none transition-colors"
                      placeholder="Enter your email"
                    />
                  </div>
                </div>

                {/* Ticket Selection */}
                <div className="mb-6 relative z-10">
                  <h3 className="text-2xl font-bold text-blue-800 mb-4 flex items-center gap-2">
                    Select Tickets
                  </h3>

                  <div className="space-y-4">
                    {/* 5-10 Years */}
                    <div className="bg-gradient-to-r from-blue-50 to-cyan-50 p-5 rounded-2xl border-2 border-blue-200">
                      <div className="flex items-center justify-between mb-3">
                        <div>
                          <p className="font-bold text-lg text-gray-800">
                            Upto 10 Years 👧👦
                          </p>
                          <p className="text-blue-600 font-bold text-2xl">
                            ₹{ticketPrices.category_5_10}
                          </p>
                        </div>
                        <div className="flex items-center gap-3">
                          <button
                            type="button"
                            onClick={() =>
                              updateTicketCount("category_5_10", false)
                            }
                            className="w-10 h-10 bg-red-500 hover:bg-red-600 rounded-full flex items-center justify-center text-white font-bold shadow-lg transition-colors"
                          >
                            <Minus className="w-5 h-5" />
                          </button>
                          <span className="text-2xl font-bold text-gray-800 w-12 text-center">
                            {formData.tickets.category_5_10}
                          </span>
                          <button
                            type="button"
                            onClick={() =>
                              updateTicketCount("category_5_10", true)
                            }
                            className="w-10 h-10 bg-green-500 hover:bg-green-600 rounded-full flex items-center justify-center text-white font-bold shadow-lg transition-colors"
                          >
                            <Plus className="w-5 h-5" />
                          </button>
                        </div>
                      </div>
                    </div>

                    {/* Above 10 Years */}
                    <div className="bg-gradient-to-r from-blue-50 to-indigo-50 p-5 rounded-2xl border-2 border-blue-200">
                      <div className="flex items-center justify-between mb-3">
                        <div>
                          <p className="font-bold text-lg text-gray-800">
                            Adults 👨‍👩‍👧‍👦
                          </p>
                          <p className="text-blue-600 font-bold text-2xl">
                            ₹{ticketPrices.category_10_above}
                          </p>
                        </div>
                        <div className="flex items-center gap-3">
                          <button
                            type="button"
                            onClick={() =>
                              updateTicketCount("category_10_above", false)
                            }
                            className="w-10 h-10 bg-red-500 hover:bg-red-600 rounded-full flex items-center justify-center text-white font-bold shadow-lg transition-colors"
                          >
                            <Minus className="w-5 h-5" />
                          </button>
                          <span className="text-2xl font-bold text-gray-800 w-12 text-center">
                            {formData.tickets.category_10_above}
                          </span>
                          <button
                            type="button"
                            onClick={() =>
                              updateTicketCount("category_10_above", true)
                            }
                            className="w-10 h-10 bg-green-500 hover:bg-green-600 rounded-full flex items-center justify-center text-white font-bold shadow-lg transition-colors"
                          >
                            <Plus className="w-5 h-5" />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Total Summary */}
                <div className="bg-gradient-to-r from-blue-100 to-cyan-100 p-6 rounded-2xl border-2 border-blue-300 mb-6 relative z-10">
                  <div className="flex justify-between items-center mb-2">
                    <span className="text-gray-700 font-bold text-lg">
                      Total Tickets:
                    </span>
                    <span className="text-2xl font-bold text-blue-600">
                      {getTotalTickets()}
                    </span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span className="text-gray-700 font-bold text-lg">
                      Total Amount:
                    </span>
                    <span className="text-3xl font-bold text-blue-600">
                      ₹{calculateTotal()}
                    </span>
                  </div>
                  <p className="text-sm text-gray-600 mt-2 text-center">
                    Payment will be collected by admin
                  </p>
                </div>

                {/* Submit Button */}
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-full py-4 bg-gradient-to-r from-blue-600 to-blue-700 text-white text-xl font-bold rounded-2xl shadow-2xl hover:from-blue-700 hover:to-blue-800 transition-all duration-300 border-2 border-blue-800 disabled:opacity-50 disabled:cursor-not-allowed relative z-10"
                >
                  {isSubmitting ? (
                    <span className="flex items-center justify-center gap-2">
                      <div className="w-6 h-6 border-3 border-white border-t-transparent rounded-full animate-spin" />
                      Processing...
                    </span>
                  ) : (
                    <span className="flex items-center justify-center gap-3">
                      Confirm Booking
                    </span>
                  )}
                </button>
              </form>
            </div>
          </div>
        </>
      )}

      {/* Success Modal */}
      {isSuccessModalOpen && (
        <>
          {/* Backdrop */}
          <div
            className="fixed inset-0 bg-black/80 backdrop-blur-md z-[9998]"
            onClick={handleCloseSuccess}
          />

          {/* Modal */}
          <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4 pointer-events-none">
            <div
              className="w-full max-w-md bg-white rounded-3xl shadow-2xl overflow-hidden pointer-events-auto animate-scaleIn"
              onClick={(e) => e.stopPropagation()}
            >
              {/* Success Content */}
              <div className="p-8 text-center">
                {/* Animated Success Icon */}
                <div className="mb-6 flex justify-center">
                  <div className="relative">
                    <div className="w-24 h-24 bg-green-100 rounded-full flex items-center justify-center animate-bounce">
                      <CheckCircle className="w-16 h-16 text-green-600" />
                    </div>
                    {/* Confetti effect */}
                    <div className="absolute inset-0 flex items-center justify-center">
                      <div className="w-32 h-32 animate-ping opacity-20">
                        <div className="w-full h-full bg-green-400 rounded-full"></div>
                      </div>
                    </div>
                  </div>
                </div>

                <h2
                  className="text-3xl font-bold text-gray-900 mb-3"
                  style={{ fontFamily: "'Poppins', sans-serif" }}
                >
                  Booking Successful! 🎉
                </h2>

                <p
                  className="text-lg text-gray-600 mb-6"
                  style={{ fontFamily: "'Poppins', sans-serif" }}
                >
                  Your ticket reservation has been confirmed. Our team will
                  contact you soon with further instructions.
                </p>

                <div className="bg-gradient-to-r from-green-50 to-emerald-50 p-6 rounded-2xl mb-6 border-2 border-green-200">
                  <p className="text-sm text-gray-700 font-semibold mb-2">
                    Booking Details
                  </p>
                  <div className="text-left space-y-2">
                    <div className="flex justify-between">
                      <span className="text-gray-600">Total Tickets:</span>
                      <span className="font-bold text-gray-900">
                        {bookingDetails.ticketCount}
                      </span>
                    </div>
                    <div className="flex justify-between">
                      <span className="text-gray-600">Total Amount:</span>
                      <span className="font-bold text-green-600 text-xl">
                        ₹{bookingDetails.totalPrice}
                      </span>
                    </div>
                  </div>
                </div>

                <button
                  onClick={handleCloseSuccess}
                  className="w-full bg-gradient-to-r from-green-600 to-emerald-600 text-white px-8 py-4 rounded-full font-bold text-lg hover:from-green-700 hover:to-emerald-700 transition-all shadow-lg transform hover:scale-105"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </>
      )}

      <style jsx>{`
        @import url("https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;600;700;800;900&display=swap");
        @import url("https://fonts.googleapis.com/css2?family=Cinzel+Decorative:wght@400;700;900&display=swap");

        @keyframes fadeIn {
          from {
            opacity: 0;
          }
          to {
            opacity: 1;
          }
        }

        @keyframes scaleIn {
          from {
            opacity: 0;
            transform: scale(0.9);
          }
          to {
            opacity: 1;
            transform: scale(1);
          }
        }

        .animate-fadeIn {
          animation: fadeIn 0.3s ease-out;
        }

        .animate-scaleIn {
          animation: scaleIn 0.3s ease-out;
        }

        /* Performance optimizations */
        * {
          -webkit-font-smoothing: antialiased;
          -moz-osx-font-smoothing: grayscale;
        }

        /* Smooth scrolling */
        html {
          scroll-behavior: smooth;
        }

        /* GPU acceleration for transforms */
        .will-change-transform {
          will-change: transform;
        }

        /* Video performance optimizations */
        video {
          transform: translateZ(0);
          -webkit-transform: translateZ(0);
          backface-visibility: hidden;
          -webkit-backface-visibility: hidden;
          perspective: 1000px;
          -webkit-perspective: 1000px;
        }

        /* Image optimization */
        img {
          image-rendering: -webkit-optimize-contrast;
          image-rendering: crisp-edges;
        }

        /* Reduce repaints */
        .fixed {
          backface-visibility: hidden;
          perspective: 1000px;
        }

        /* Custom scrollbar for vertical video section */
        .custom-scrollbar::-webkit-scrollbar {
          width: 8px;
        }

        .custom-scrollbar::-webkit-scrollbar-track {
          background: #f1f1f1;
          border-radius: 10px;
        }

        .custom-scrollbar::-webkit-scrollbar-thumb {
          background: linear-gradient(to bottom, #ec4899, #8b5cf6);
          border-radius: 10px;
        }

        .custom-scrollbar::-webkit-scrollbar-thumb:hover {
          background: linear-gradient(to bottom, #db2777, #7c3aed);
        }
      `}</style>
    </div>
  );
};

export default HoliPage;
